export const numberToWords = (num) => {
  if (num === 0) return "Zero Rupees Only";

  const ones = [
    "",
    "One",
    "Two",
    "Three",
    "Four",
    "Five",
    "Six",
    "Seven",
    "Eight",
    "Nine",
    "Ten",
    "Eleven",
    "Twelve",
    "Thirteen",
    "Fourteen",
    "Fifteen",
    "Sixteen",
    "Seventeen",
    "Eighteen",
    "Nineteen",
  ];

  const tens = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];

  const scales = ["", "Thousand", "Lakh", "Crore"];

  const convertToWords = (n) => {
    let word = "";

    if (n >= 100) {
      word += ones[Math.floor(n / 100)] + " Hundred ";
      n %= 100;
    }

    if (n >= 20) {
      word += tens[Math.floor(n / 10)] + " ";
      n %= 10;
    }

    if (n > 0) {
      word += ones[n] + " ";
    }

    return word.trim();
  };

  const [integerPart, decimalPart] = num.toString().split(".");
  let number = parseInt(integerPart, 10);

  const parts = [];

  // Last 3 digits
  parts.push(number % 1000);
  number = Math.floor(number / 1000);

  // Remaining in 2-digit groups
  while (number > 0) {
    parts.push(number % 100);
    number = Math.floor(number / 100);
  }

  let words = "";

  for (let i = parts.length - 1; i >= 0; i--) {
    if (parts[i] > 0) {
      words += convertToWords(parts[i]) + (scales[i] ? " " + scales[i] : "") + " ";
    }
  }

  words = words.trim() + " Rupees";

  if (decimalPart) {
    const paise = Math.round(parseFloat("0." + decimalPart) * 100);
    if (paise > 0) {
      words += " and " + convertToWords(paise) + " Paise";
    }
  }

  return words + " Only";
};
